export function saveUtmParamsOnce() {
  const params = new URLSearchParams(window.location.search);
  let needSave = false;
  const utm = {};
  for (const [key, value] of params.entries()) {
    if (key.startsWith('utm_')) {
      utm[key] = value;
      needSave = true;
    }
  }
  // Сохраним только если есть utm
  if (needSave) {
    localStorage.setItem('utm', JSON.stringify(utm));
  }
}
export function getSavedUtm() {
  const raw = localStorage.getItem('utm');
  return raw ? JSON.parse(raw) : {};
}